
import { SplashLoadingText } from "GameObjects/Splash/SplashLoadingText";
import { Sine } from "gsap/EasePack";
import { TweenLite } from "gsap/TweenLite";
import * as HLF from "html-living-framework";
import { makeSprite } from "html-living-framework/lib/Utils/PixiUtils";

export class SplashScreen extends HLF.SplashScreen {
    private _bg!: PIXI.Sprite;
    private _loadingText!: SplashLoadingText;
    private readonly _callback!: () => void;
    private readonly _versionText?: PIXI.extras.BitmapText;

    public constructor() {
        super();
    }

    public init(pSize: PIXI.Point) {
        super.init(pSize);
        PubSub.publishSync(HLF.PUSH_KEYBOARD_LAYER, undefined);

        this._bg = makeSprite("splash/splash-background");
        this._bg.interactive = true;
        this.addChild(this._bg);

        const luna = this.addChild(makeSprite("splash/splash-luna"));
        luna.position.set(514.5 - 832, 593 - 384 + (424 - 350) / 2);

        const logo = this.addChild(makeSprite("splash/splash-logo"));
        logo.position.set(-332.75 + (321.7 / 4), 209.25 - 384);

        this._loadingText = new SplashLoadingText();
        this._loadingText.position.set(0, 64.25);
        this.addChild(this._loadingText);

        // const text = `${V.PACKAGE_NAME} @ ${V.GIT_BRANCH} v${V.PACKAGE_VERSION}\n${V.BUILD_DATE}\n${V.GIT_COMMIT}`;
        // this._versionText = HLF.PixiUtils.makeText(text, Constants.FONT_GEL_MED_35, 35, HLF.Colour.WHITE.toHex());
        // this._versionText.anchor = new PIXI.Point(1, 1);
        // this._versionText.position.set(pSize.x / 2 - 10, pSize.y / 2 - 10);
        // this._versionText.align = "right";
        // this.addChild(this._versionText);
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);
        this._versionText?.position.set(pSize.x / 2 - 10, pSize.y / 2 - 10);
    }

    public animateIn(pOnComplete: () => void): void {
        this._loadingText.animateIn(pOnComplete);
    }

    public animateOut(pOnComplete: () => void): void {
        PubSub.publishSync(HLF.POP_KEYBOARD_LAYER, undefined);

        TweenLite.to([this._versionText, this._loadingText], 0.5, {
            alpha: 0,
            ease: Sine.easeInOut,
            onComplete: pOnComplete,
        });
    }

    public onLoadComplete(pCallback: () => void): void {
        pCallback();
    }
}
